import { Message, fromJson, toJson } from '@bufbuild/protobuf';
import { GenMessage } from '@bufbuild/protobuf/codegenv2';

/**
 * Converts a message to a sibling message with an identical field shape, by
 * round-tripping through JSON with the correct schema on each side.
 *
 * Needed because several RPCs (Get, Update) return a distinct proto message
 * from the corresponding Create response, even though the fields are
 * identical by design - protobuf-es v2's reflection-based codecs enforce the
 * message's actual descriptor, so a same-shaped message read through the
 * wrong schema throws ForeignFieldError rather than being read structurally.
 */
export function reencode<From extends Message, To extends Message>(
  fromSchema: GenMessage<From>,
  toSchema: GenMessage<To>,
  value: From,
): To {
  return fromJson(
    toSchema,
    toJson(fromSchema, value, { alwaysEmitImplicit: true }),
  );
}
